import { createFileRoute } from "@tanstack/react-router";
import { ApiKeysSeite } from "@/components/ApiKeysSeite";

/*
 * `/admin/api-keys` — die Token für den maschinellen Inventur-Push.
 *
 * Der Unterstrich in `admin_.api-keys.tsx` löst diese Route aus `admin.tsx`
 * heraus, genau wie bei `admin_.upload.tsx` und `admin_.archiv.tsx`: sie liegt
 * PFADLICH unter `/admin`, aber nicht in dessen Layout. Ohne ihn würde
 * `admin.tsx` zur Layout-Route, ihre Landeseite stünde über jeder Unterseite,
 * und `/admin` bräuchte eine zusätzliche Index-Route. Nachgesehen wird das am
 * Generat (`fullPaths`), nicht geraten.
 *
 * Der Bindestrich im Dateinamen ist ein gewöhnliches Pfadzeichen und hat mit
 * der Herauslösung nichts zu tun — nur der Unterstrich VOR dem Punkt wirkt.
 *
 * Kein `loader`: die Sicht erfragt Zugang und Daten in EINEM Aufruf und hat
 * außerdem zwei Mutationen mit eigenen Fehlerzuständen. Das gehört in die
 * Komponente, die es anzeigt.
 */
export const Route = createFileRoute("/admin_/api-keys")({
  component: ApiKeysSeite,
});
